import { useState } from 'react';

import { EMAIL } from '../../utils/constants';
import { usePreviewIframe } from '../Posts/hooks/usePreviewIframe';
import { useCampaignContext } from '../../contexts/CampaignContext.jsx';

import { MessageForm } from './MessageForm.jsx';
import { MessageFormPreview } from '../Posts/MessageFormPreview.jsx';

export const NotificationStep = ({ messageForm, tab }) => {
  const [currentPreview, setCurrentPreview] = useState(EMAIL);
  const { campaign } = useCampaignContext();
  const {
    message,
    setFieldValue,
    handleChange,
    values,
    onSendTest,
  } = messageForm;

  const { updateIframe, iframeRef, iframeSrc } = usePreviewIframe({
    form: messageForm,
    message,
    tab,
  });

  return (
    <>
      <MessageForm
        message={message}
        values={values}
        handleChange={handleChange}
        setFieldValue={setFieldValue}
        currentPreview={currentPreview}
        setCurrentPreview={setCurrentPreview}
        onSendTest={onSendTest}
        audiences={campaign?.audiences || []}
      />
      <MessageFormPreview
        demoCustomName={message?.demoCustomName}
        demoName={message?.demoName}
        demoEmail={message?.demoEmail}
        iframeSrc={iframeSrc}
        iframeRef={iframeRef}
        currentPreview={currentPreview}
        setCurrentPreview={setCurrentPreview}
        updateIframe={updateIframe}
        values={values}
      />
    </>
  );
};
